import React from 'react'
import { TextField } from '@material-ui/core'

function CustomTextField(props) {
    const { name, formState } = props
    const properProps = Object.assign({}, props)
    delete properProps['formState'];

    return (
        <TextField
            fullWidth
            value={formState[name]['value']}
            error={formState[name]['error']}
            helperText={formState[name]['error'] && formState[name]['helperText']}
            {...(properProps)}
        />
    )
}

export default CustomTextField